import { StrictMode, lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { PostHogProvider } from '@posthog/react';
import posthog from './lib/posthog';
import './index.css';

// World links in the Lora app carry src=lora-app. The cookie spans every getlora.com
// site so signup routes can skip their welcome email for people already in the app.
if (new URLSearchParams(window.location.search).get('src') === 'lora-app') {
  document.cookie =
    'lora_src=app; Domain=.getlora.com; Path=/; Max-Age=31536000; SameSite=Lax; Secure';
}



// Lazy load the main App component for code splitting
const App = lazy(() => import('./App'));

// Simple loading fallback
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#0165e0',
    color: 'white',
    fontSize: '18px',
    fontFamily: 'system-ui, -apple-system, sans-serif'
  }}>
  </div>
);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider client={posthog}>
      <Suspense fallback={<LoadingFallback />}>
        <App />
      </Suspense>
    </PostHogProvider>
  </StrictMode>,
);;